import { State } from 'src/types'
import { hamidashiOfWingTip } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/hamidashi/wingTip'
import { wingTipBackStyle } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/wingTipBackStyle'
import { middleFingerLeft, middleFingerRight } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/ringFinger'
import { indexFingerLeft } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/indexFinger'
import { littleFingerLeft, littleFingerRight } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/littleFinger'
import { thumbAndListBelt, thumbOut } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/thumbAndListBelt'
import { listBelt } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/listBelt'
import { indexFingerPad } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/fingerCoverOrPad/indexFingerPad'
import { catchFace2 } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/catchFace2'
import { edgeOfBeltBackStyle } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/edge/edgeOfWrist'
import { middleFingerPad } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/fingerCoverOrPad/middleFIngerPad'
import { startInversion, thumbEmbroideryDrawerLeftThrow, undoInversion } from 'src/util/canvas'

// 王冠モデル
export const crownBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean, canvasWidth: number): void => {
  if (state.backStyle?.value !== 'crownBackStyle' && state?.baseModel?.backStyle !== 'crownBackStyle') return

  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)

  // 親指指袋_手口ベルト(下地)

  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch.color)
  // 親指＿外
  thumbOut(ctx, state.thumbOut.color)

  if (['normal', 'unselected', undefined].includes(state.beltType?.value)) {
    listBelt(ctx, state.listBelt.color, state.stitch.color)
  }

  // 人差し指＿左
  indexFingerLeft(ctx, state.indexLeftMiddleRight?.color)

  // 中指＿右
  middleFingerRight(ctx, state?.indexLeftMiddleRight?.color)
  // 中指＿左
  middleFingerLeft(ctx, state?.middleLeftRingRight?.color)

  // 薬指＿右
  ringFingerRight(ctx, state?.middleLeftRingRight?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state?.ringLeftLittleRight?.color)

  // 小指＿右
  littleFingerRight(ctx, state?.ringLeftLittleRight?.color)
  // 小指＿左
  littleFingerLeft(ctx, state?.littleOut?.color)

  wingTipBackStyle(ctx, state.indexWeb.color)

  hamidashiOfWingTip(ctx, state.hamidashi.color)
  // 指当て
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, state.stitch.color, -165, 90, -15)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)

  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace.color, state.stitch.color, needCatchFaceWrap)
  edgeOfBeltBackStyle(ctx, state.edge.color, state.stitch.color)
  edgeOfWrist(ctx, state.edge.color, state.stitch.color)

  // 親指への刺繍
  undoInversion(ctx, canvasWidth)
  thumbEmbroideryDrawerLeftThrow(ctx, state.embroideries, state.backStyle)
  startInversion(ctx, canvasWidth)
}
